export default __webpack_public_path__ + "static/main-ec2f5607463a598b358c7b3f392f69f9.png";